module.exports = __webpack_public_path__ + "img/Palasiet.b3ba5cea.png";